module.exports = __webpack_public_path__ + "img/keypal-main.0071c230.png";